module.exports = __webpack_public_path__ + "img/google-pay.54aea8da.png";